<template>

    <div class="c-form_select">
        <form-label>{{ label }}</form-label>
        <div
            class="c-form_select__inner"
            :class="{ 'c-form_select__inner--with-btn' : btn}">

            <div class="c-form_select__inner-select" :class="getClasses">
                <v-select2
                    v-model="newValue"
                    :options="getOptions"
                    :ajax-url="getAjaxUrl"
                    :format-item="formatItem">
                </v-select2>
            </div>

            <v-btn
                v-if="btn"
                :type="btn"
                class="c-form_select__btn"
                :class="{ 'c-form_select__btn--hidden' : !btnVisible }"
                @click="btnClick"
                :disabled="disabled"
                :hasLoader="btnHasLoader"
                :loading="btnLoading">
                {{ btnLabel }}
            </v-btn>
        </div>
        <form-error-msg :msg="error || getError"></form-error-msg>
    </div>

</template>


<script>

import VBtn from 'Components/VBtn'
import FormLabel from './FormLabel'
import FormErrorMsg from './FormErrorMsg'
import VSelect2 from 'Components/VSelect2'

export default {

    name: 'FormSelect',

    inheritAttrs: false,

    $_veeValidate: {
        name() {
            return this.inputName
        },
        value() {
            return this.value
        },
    },

    props: {
        value: [String, Number],
        options: Array,
        ajaxUrl: String,
        formatItem: Function,
        label: String,
        name: String,
        btn: String,
        btnLabel: String,
        btnHasLoader: Boolean,
        btnLoading: Boolean,
        btnVisible: {
            type: Boolean,
            default: true
        },
        disabled: Boolean,
        error: String
    },

    data() {
        return {
            newValue: this.value
        }
    },

    computed: {
        inputName() {
            var tmp_name = this.$vnode.data.model.expression.split('.')
            var name = ''

            if (tmp_name.length > 1)
                name = tmp_name[tmp_name.length - 1]
            else
                name = tmp_name[0]

            return this.name || name
        },
        getError() {
            var err = this.errors.items.filter((error) => {
                return (error.field === this.inputName)
            })

            if (err.length)
                return err[0].msg
            else
                return null
        },
        getOptions() {
            const len = this.options ? this.options.length : 0
            var opts = []
            for (let i = 0; i < len; i++) {
                opts.push({
                    text: this.options[i].name.toString(),
                    id: parseInt(this.options[i].id)
                })
            }
            return opts
        },
        getAjaxUrl() {
            return this.ajaxUrl
        },
        getClasses() {
            return {
                'c-form_select__inner-select--error': this.getError
            }
        }
    },

    watch: {
        value(value) {
            this.newValue = value
        },
        newValue(value) {
            this.$emit('input', value)
        }
    },

    methods: {
        btnClick(e) {
            e.preventDefault()
            this.$emit('click', this.value)
        }
    },

    components: {
        VBtn,
        FormLabel,
        FormErrorMsg,
        VSelect2
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-form_select {
    width: 100%;
    margin-bottom: 1rem;

    &__inner {
        display: flex;

        &-select {
            width: 100%;

            &--error .select2-selection {
                border-color: $c-red;
            }
        }
    }
    &__btn {
        margin-left: 0.7rem;
        opacity: 1;
        transition: opacity .2s ease-in-out;

        &--hidden {
            pointer-events: none;
            opacity: 0;
        }
    }
}

</style>


